export const EventSourceStrings = {
  ADD_FUNDS_WALLET_REGISTRATION_STEP: 'ADD_FUNDS_WALLET_REGISTRATION_STEP',
  SELLER_BRANDING: 'SELLER_BRANDING',
  STORE_BRANDING: 'STORE_BRANDING',
  CARRIER_SETTINGS: 'CARRIER_SETTINGS',
  FTU_WIZARD_AUTOMATION_RULES: 'FTU_WIZARD_AUTOMATION_RULES',
  FTU_WIZARD_CARRIER_STEP: 'FTU_WIZARD_CARRIER_STEP',
  FTU_WIZARD_IMPORT_CSV: 'FTU_WIZARD_IMPORT_CSV',
  FTU_WIZARD_ADD_ANOTHER_STORE: 'FTU_WIZARD_ADD_ANOTHER_STORE',
  FTU_WIZARD_ORDERS_PAGE: 'FTU_WIZARD_ORDERS_PAGE',
  FTU_WIZARD_RETURNS_STEP: 'FTU_WIZARD_RETURNS_STEP',
  FTU_WIZARD_SIMPLIFIED_DROPDOWN: 'FTU_WIZARD_SIMPLIFIED_DROPDOWN',
  FTU_WIZARD_INVENTORY_STEP: 'FTU_WIZARD_INVENTORY_STEP',
  GETTING_STARTED_GUIDE_IMPORT_ORDERS: 'GETTING_STARTED_GUIDE_IMPORT_ORDERS',
  GRID_CSW: 'GRID_CSW',
  GRID_HOT_KEY: 'GRID_HOT_KEY',
  HOME_PAGE_CONNECT_CARRIER: 'HOME_PAGE_CONNECT_CARRIER',
  HOME_PAGE_FEED_CARD: 'HOME_PAGE_FEED_CARD',
  HOME_PAGE_FEED: 'HOME_PAGE_FEED',
  HOME_PAGE_ONBOARDING_STEP: 'HOME_PAGE_ONBOARDING_STEP',
  INSURANCE_SETTINGS_CONTENT: 'INSURANCE_SETTINGS_CONTENT',
  INSURANCE_SETTINGS: 'INSURANCE_SETTINGS',
  CSW_INSURANCE_FIELD: 'CSW_INSURANCE_FIELD',
  INSURANCE_CLAIMS_MODAL: 'INSURANCE_CLAIMS_MODAL',
  INSURANCE_TERMS_MODAL: 'INSURANCE_TERMS_MODAL',
  LABEL_BATCH_COST_REVIEW: 'LABEL_BATCH_COST_REVIEW',
  LABEL_PRINT_SETTINGS_LINK: 'onboard-select a label layout modal',
  MY_ACCOUNT_DROPDOWN: 'MY_ACCOUNT_DROPDOWN',
  NEW_RULE_BUTTON: 'NEW_RULE_BUTTON',
  OLD_RETURN_LABEL_BUTTON: 'OLD_RETURN_LABEL_BUTTON',
  ON_FIRST_LOGIN: 'ON_FIRST_LOGIN',
  ONBOARD_CONNECT_EXISTING_CARRIER_ACCOUNT_LINK: 'onboard-connect existing carrier account link',
  ONBOARD_MARKETPLACE_STEP: 'ONBOARD_MARKETPLACE_STEP',
  ONBOARD_PAGE: 'ONBOARD_PAGE',
  ONBOARD_SETUP_CARRIERS_BUTTON: 'ONBOARD_SETUP_CARRIERS_BUTTON',
  ORDER_DETAILS_CSW: 'ORDER_DETAILS_CSW',
  ORDER_DETAILS_HEADER: 'ORDER_DETAILS_HEADER',
  ORDER_DETAILS_HOT_KEY: 'ORDER_DETAILS_HOT_KEY',
  ORDER_DETAILS_SIDEBAR: 'ORDER_DETAILS_SIDEBAR',
  ORDER_GRID_HEADER_NEW_GRID_BUTTON: 'ORDER_GRID_HEADER_NEW_GRID_BUTTON',
  ORDER_GRID_HEADER_OTHER_ACTIONS_DROPDOWN: 'ORDER_GRID_HEADER_OTHER_ACTIONS_DROPDOWN',
  ORDER_GRID_HEADER_TAG_DROPDOWN: 'ORDER_GRID_HEADER_TAG_DROPDOWN',
  ORDERS_GRID_EMPTY_STATE_CONNECT_EXISTING_CARRIERS: 'ORDERS_GRID_EMPTY_STATE_CONNECT_EXISTING_CARRIERS',
  ORDERS_GRID_EMPTY_STATE_IMPORT_CSV: 'ORDERS_GRID_EMPTY_STATE_IMPORT_CSV',
  ORDERS_GRID_EMPTY_STATE_SET_UP_AUTOMATIONS: 'ORDERS_GRID_EMPTY_STATE_SET_UP_AUTOMATIONS',
  ORDERS_GRID_EMPTY_STATE_WALLET_REGISTRATION: 'ORDERS_GRID_EMPTY_STATE_WALLET_REGISTRATION',
  ORDERS_GRID_EMPTY_STATE_DEMO_ORDER: 'ORDERS_GRID_EMPTY_STATE_DEMO_ORDER',
  ORDERS_GRID_EMPTY_STATE: 'ORDERS_GRID_EMPTY_STATE',
  PROCESS_SHIPMENTS_BUTTON: 'PROCESS_SHIPMENTS_BUTTON',
  RATE_AND_CREATE: 'RATE_AND_CREATE',
  RETURN_LABEL_BUTTON: 'RETURN_LABEL_BUTTON',
  ENHANCED_RETURN_LABEL_BUTTON: 'ENHANCED_RETURN_LABEL_BUTTON',
  RETURNS_GRID_PLACEHOLDER: 'RETURNS_GRID_PLACEHOLDER',
  RULE_COPY_LINK: 'RULE_COPY_LINK',
  RULE_EDITOR_LINK: 'RULE_EDITOR_LINK',
  SETTINGS_CARRIERS_PAGE_BANNER: 'SETTINGS_CARRIERS_PAGE_BANNER_BUTTON',
  SETTINGS_CARRIERS_PAGE_TABLE: 'SETTINGS_CARRIERS_PAGE_TABLE_ACTION_BUTTON',
  SETTINGS_CARRIERS_PAGE: 'SETTINGS_CARRIERS_PAGE',
  SETTINGS_PACKAGES_PAGE: 'SETTINGS_PACKAGES_PAGE',
  SHIPMENTS_GRID_HEADER: 'SHIPMENTS_GRID_HEADER',
  SHIPMENT_MODAL_HEADER: 'SHIPMENT_MODAL_HEADER',
  STORE_SETTINGS_RETURNS_TAB: 'STORE_SETTINGS_RETURNS_TAB',
  STORE_SETUP_PAGE: 'STORE_SETUP_PAGE',
  TOP_NAV: 'TOP_NAV',
  TOP_NAV_ANALYTICS: 'TOP_NAV_ANALYTICS',
  TOP_NAV_RETURNS: 'TOP_NAV_RETURNS',
  TOP_NAV_PRODUCTS: 'TOP_NAV_PRODUCTS',
  TOP_NAV_SCAN: 'TOP_NAV_SCAN',
  TOP_NAV_SUPPLIES: 'TOP_NAV_SUPPLIES',
  UPSELL_MODAL: 'UPSELL_MODAL',
  WALLET_BALANCE_INFO: 'WALLET_BALANCE_INFO',
  WALLET_UPDATE_POPUP: 'WALLET_UPDATE_POPUP',
  SCAN_TO_PRINT: 'SCAN_TO_PRINT',
  RATE_BROWSER_MISSING_SHIP_FROM: 'RATE_BROWSER_MISSING_SHIP_FROM',
  SETTINGS_SHIP_FROM_LOCATIONS: 'SETTINGS_SHIP_FROM_LOCATIONS',
  SHIPPY_ASSISTANT: 'SHIPPY_ASSISTANT',
  AI_RULE_CREATOR: 'AI_RULE_CREATOR',
  MISSING_SHIP_FROM: 'MISSING_SHIP_FROM',
  RATE_BROWSER_EMPTY_STATE: 'RATE_BROWSER_EMPTY_STATE',
  PLAYBOOK_TEMPLATE: 'PLAYBOOK_TEMPLATE',
};

export const ShippyEvents = {
  SIDEBAR_OPENED: 'SHIPPY_SIDEBAR_OPENED',
  SIDEBAR_CLOSED: 'SHIPPY_SIDEBAR_CLOSED',
  EXAMPLE_QUESTION_CLICKED: 'SHIPPY_EXAMPLE_QUESTION_CLICKED',
  HANDLER_SHOWN: 'SHIPPY_HANDLER_SHOWN',
  CAPABILITY_ACTION_CLICKED: 'SHIPPY_CAPABILITY_ACTION_CLICKED',
  SIERRA_ESCALATION: 'SHIPPY_SIERRA_ESCALATION',
  SIERRA_USER_MESSAGE: 'SHIPPY_SIERRA_USER_MESSAGE',
  SIERRA_RESPONSE_RECEIVED: 'SHIPPY_SIERRA_RESPONSE_RECEIVED',
  SIERRA_LIVE_AGENT_CONNECTED: 'SHIPPY_SIERRA_LIVE_AGENT_CONNECTED',
  SIERRA_LIVE_AGENT_MESSAGE: 'SHIPPY_SIERRA_LIVE_AGENT_MESSAGE',
  SIERRA_CONVERSATION_ENDED: 'SHIPPY_SIERRA_CONVERSATION_ENDED',
  SURVEY_RESPONSE: 'SHIPPY_SURVEY_RESPONSE',
  CONVERSATION_COMPLETED: 'SHIPPY_CONVERSATION_COMPLETED',
  SIERRA_HELP_CENTER_OPENED: 'SHIPPY_SIERRA_HELP_CENTER_OPENED',
};

export const Workflows = {
  ACTIVATE_ENHANCED_RETURNS_FLOW: 'ACTIVATE_ENHANCED_RETURNS_FLOW',
  ADD_FUNDS_FLOW: 'ADD_FUNDS_FLOW',
  ADD_ON_FLOW: 'ADD_ON_FLOW',
  ADVANCED_SHIPPING_NOTICE_FLOW: 'ADVANCED_SHIPPING_NOTICE_FLOW',
  BILLING_INFO_FLOW: 'BILLING_INFO_FLOW',
  BULK_LABEL_PURCHASE_FLOW: 'BULK_LABEL_PURCHASE_FLOW',
  CARRIER_CONNECTION_FLOW: 'CARRIER_CONNECTION_FLOW',
  CREATE_AUTOMATION_RULES_FLOW: 'CREATE-AUTOMATION-RULES-FLOW',
  CREATE_RETURN_FLOW: 'CREATE_RETURN_FLOW',
  CSV_DANGEROUS_GOODS_IMPORT_FLOW: 'CSV_DANGEROUS_GOODS_IMPORT_FLOW',
  CSV_PRODUCT_UOM_IMPORT_FLOW: 'CSV_PRODUCT_UOM_IMPORT_FLOW',
  CSV_INVENTORY_IMPORT_FLOW: 'CSV_INVENTORY_IMPORT_FLOW',
  CSV_ORDER_IMPORT_FLOW: 'CSV_ORDER_IMPORT_FLOW',
  CSV_PRODUCT_IMPORT_FLOW: 'CSV_PRODUCT_IMPORT_FLOW',
  CSV_FTU_PRODUCT_WITH_INVENTORY_IMPORT_FLOW: 'CSV_FTU_PRODUCT_WITH_INVENTORY_IMPORT_FLOW',
  CSV_INVENTORY_LOCATION_IMPORT_FLOW: 'CSV_INVENTORY_LOCATION_IMPORT_FLOW',
  CSV_TOTE_IMPORT_FLOW: 'CSV_TOTE_IMPORT_FLOW',
  CSV_ASN_IMPORT_FLOW: 'CSV_ASN_IMPORT_FLOW',
  CSV_BLACKLIST_IMPORT_FLOW: 'CSV_BLACKLIST_IMPORT_FLOW',
  CSV_PURCHASE_ORDER_IMPORT_FLOW: 'CSV_PURCHASE_ORDER_IMPORT_FLOW',
  CSV_SUPPLIER_IMPORT_FLOW: 'CSV_SUPPLIER_IMPORT_FLOW',
  CUSTOM_PACKAGE_FLOW: 'CUSTOM_PACKAGE_FLOW',
  EDIT_INVENTORY_SYNC_FLOW: 'EDIT_INVENTORY_SYNC_FLOW',
  EDIT_INVENTORY_SYNC_OPTIONS_FLOW: 'EDIT_INVENTORY_SYNC_OPTIONS_FLOW',
  FBS_APPLICATION_FLOW: 'FBS_APPLICATION_FLOW',
  FTU_WIZARD_FLOW: 'FTU_WIZARD_FLOW',
  INVENTORY_IMPORT_FLOW: 'INVENTORY_IMPORT_FLOW',
  LABEL_LAYOUT_SELECTION_FLOW: 'LABEL_LAYOUT_SELECTION_FLOW',
  LABEL_PURCHASE_FLOW: 'LABEL_PURCHASE_FLOW',
  MARKETPLACE_CONNECTION_FLOW: 'MARKETPLACE_CONNECTION_FLOW',
  ORDER_IMPORT_FLOW: 'ORDER_IMPORT_FLOW',
  PRODUCT_IMPORT_FLOW: 'PRODUCT_IMPORT_FLOW',
  RATE_BROWSER_FLOW: 'RATE_BROWSER_FLOW',
  SCAN_TO: 'SCAN_TO',
  TAG_MANAGEMENT_FLOW: 'TAG_MANAGEMENT_FLOW',
  WALLET_REGISTRATION_FLOW: 'WALLET_REGISTRATION_FLOW',
  SCAN_TO_RECEIVE_FLOW: 'SCAN_TO_RECEIVE_FLOW',
  PURCHASE_ORDER_RECEIVE_FLOW: 'PURCHASE_ORDER_RECEIVE_FLOW',
  TRANSFER_ORDER_RECEIVE_FLOW: 'TRANSFER_ORDER_RECEIVE_FLOW',
  UPSELL_BILLING_PLAN_FLOW: 'UPSELL_BILLING_PLAN_FLOW',
  PROMOTIONAL_PLAN_MIGRATION_FLOW: 'PROMOTIONAL_PLAN_MIGRATION_FLOW',
  STORE_ERROR_RESOLUTION_FLOW: 'STORE_ERROR_RESOLUTION_FLOW',
  HARMONIZATION_SINGLE_FLOW: 'HARMONIZATION_SINGLE_FLOW',
  HARMONIZATION_BULK_FLOW: 'HARMONIZATION_BULK_FLOW',
  HTML_EDITOR_FLOW: 'HTML_EDITOR_FLOW',
};

export const BulkUpdateEvents = {
  BULK_UPDATE_COMPLETE: 'BULK_UPDATE_COMPLETE',
};

export const ClickEvents = {
  HEADER_LOGO_CLICKED: 'HEADER_LOGO_CLICKED',
  RATE_BROWSER_CHANGE_VIEW: 'RATE_BROWSER_CHANGE_VIEW',
  RATE_BROWSER_ALL_RATES_ERROR_BANNER_EXPANDED: 'RATE_BROWSER_ALL_RATES_ERROR_BANNER_EXPANDED',
  RATE_BROWSER_ALL_RATES_ERROR_BANNER_DISMISSED: 'RATE_BROWSER_ALL_RATES_ERROR_BANNER_DISMISSED',
  FTU_OFFER_RETURNS_CLICKED: 'FTU_OFFER_RETURNS_CLICKED',
  FTU_RETURNS_INITIATION_OPTION_CLICKED: 'FTU_RETURNS_INITIATION_OPTION_CLICKED',
  FTU_RETURNS_DEFAULT_SERVICE_SAVE_CLICKED: 'FTU_RETURNS_DEFAULT_SERVICE_SAVE_CLICKED',
  FTU_RETURNS_DEFAULT_SERVICE_EDIT_CLICKED: 'FTU_RETURNS_DEFAULT_SERVICE_EDIT_CLICKED',
  FTU_INCLUDE_RETURN_WITH_OUTGOING_CHECKED: 'FTU_INCLUDE_RETURN_WITH_OUTGOING_CHECKED',
  FTU_ACTIVATE_ENHANCED_RETURNS_STORE_CLICKED: 'FTU_ACTIVATE_ENHANCED_RETURNS_STORE_CLICKED',
  FTU_ACTIVATE_LEGACY_RETURNS_STORE_CLICKED: 'FTU_ACTIVATE_LEGACY_RETURNS_STORE_CLICKED',
  FTU_CUSTOMIZE_PORTAL_CLICKED: 'FTU_CUSTOMIZE_PORTAL_CLICKED',
  FTU_ACTIVATE_RETURNS_STORE_CLICKED: 'FTU_ACTIVATE_RETURNS_STORE_CLICKED',
  FTU_DEACTIVATE_RETURNS_STORE_CLICKED: 'FTU_DEACTIVATE_RETURNS_STORE_CLICKED',
  FTU_COPY_PORTAL_URL_CLICKED: 'FTU_COPY_PORTAL_URL_CLICKED',
  FTU_LEGACY_RETURNS_STORE_SAVE_CONFIGURATION_CLICKED: 'FTU_LEGACY_RETURNS_STORE_SAVE_CONFIGURATION_CLICKED',
  FTU_LEGACY_RETURNS_STORE_CANCEL_CLICKED: 'FTU_LEGACY_RETURNS_STORE_CANCEL_CLICKED',
  FTU_CARRIER_STEP_ACTIVATE_CARRIERS_CLICKED: 'FTU_CARRIER_STEP_ACTIVATE_CARRIERS_CLICKED',
  FTU_INVENTORY_MANAGEMENT_OPTION_SELECTED: 'FTU_INVENTORY_MANAGEMENT_OPTION_SELECTED',
  FTU_UPLOAD_CSV_SELECTED: 'FTU_UPLOAD_CSV_SELECTED',
  FTU_NO_ORDERS_YET_SELECTED: 'FTU_NO_ORDERS_YET_SELECTED',
  FTU_ADD_MANUAL_ORDER_CLICKED: 'FTU_ADD_MANUAL_ORDER_CLICKED',
};
